<template>
<div>
  <header>
    <div class="logo"></div>
    <a class="headerBtn" href="">登出</a>
  </header>
  <div class="mainWrap">

    <div class="dataWrap">

      <div class="dataBox">
        <ul>
          <li><input type="radio" id="event_1" name="event"> <label for="event_1">放大吧！積木村特展＠華山</label></li>
          <li><input type="radio" id="event_2" name="event"> <label for="event_2">積木村特展＠華山</label></li>
        </ul>
      </div>
      <div class="reavtion"><a href="#">確定</a></div>
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: "FirmEvent"
}
</script>

<style scoped src="../../public/css/firm.default.css" />
<style scoped src="../../public/css/firm.default.date.css" />
<style scoped src="../../public/css/firm.reset.css" />
<style scoped src="../../public/css/firm.system.css" />

